import styled from '@emotion/styled';
import React, { useMemo } from 'react';
import { palette } from '~/utils/colours';

const CountInvalid = styled.p`
  color: ${palette.brightOrange};
  pointer-events: none;
  bottom: -8px !important;
`;

const CountValid = styled.p`
  color: #a6a6a6;
  pointer-events: none;
  bottom: -8px !important;
`;

export interface CharacterLimitProps {
  limit: number;
  input: string | undefined;
  style: React.HTMLAttributes<HTMLTextAreaElement>['style'];
}

export default function CharacterLimit(props: CharacterLimitProps) {
  const { isValid, count } = useMemo(() => {
    const isValid = (props.input ?? '').length < props.limit;
    const count = props.limit - (props.input ?? '').length;

    return {
      isValid,
      count,
    };
  }, [props.input, props.limit]);
  if (!isValid) {
    return <CountInvalid style={props.style}>{count}</CountInvalid>;
  }
  return <CountValid style={props.style}>{count}</CountValid>;
}
